mutation processXeroAuthCallback($callbackUrl: String!) {
  processXeroAuthCallback(callbackUrl: $callbackUrl) {
    __typename
    isTokenSetValid
  }
}
